import React from 'react';
import { MessageSquare, Mail, FileText } from 'lucide-react';

const AdminMessagesTab = ({ 
  messages, 
  formatDate,
  onGenerateResponse
}) => {
  const getSourceBadge = (source, toAddress) => {
    if (source === 'inbound_email') {
      return (
        <span className="source-badge inbound" title={`Sent to: ${toAddress || 'N/A'}`}>
          <Mail className="h-3 w-3" /> Email
        </span>
      );
    }
    return (
      <span className="source-badge form">
        <FileText className="h-3 w-3" /> Form
      </span>
    );
  };

  return (
    <div className="admin-card full-width" data-testid="messages-tab">
      <h2><MessageSquare className="h-5 w-5" /> Messages & Inquiries</h2>
      {messages.length > 0 ? (
        <div className="messages-list">
          {messages.map((msg, idx) => (
            <div key={msg._id || `${msg.email}-${msg.created_at}`} className={`message-item ${msg.status}`} data-testid={`message-item-${msg._id || msg.email}`}>
              <div className="message-header">
                <div className="message-sender">
                  <span className="sender-name">{msg.name}</span>
                  <span className="sender-email">{msg.email}</span>
                  {getSourceBadge(msg.source, msg.to_address)}
                </div>
                <span className={`message-status ${msg.status || 'new'}`}>{msg.status || 'NEW'}</span>
              </div>
              <div className="message-subject">{msg.subject || 'General Inquiry'}</div>
              <div className="message-body">{msg.message}</div>
              <div className="message-footer">
                <span className="message-date">{formatDate(msg.created_at)}</span>
                <div className="message-actions">
                  <button 
                    onClick={() => onGenerateResponse(msg)}
                    className="generate-response-link"
                    data-testid={`generate-response-btn-${idx}`}
                  >
                    Generate AI Response
                  </button>
                  <a 
                    href={`mailto:${msg.email}?subject=Re: ${msg.subject || 'Your message to Washed Away'}`}
                    className="reply-link"
                  >
                    Reply via Email
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="admin-empty">
          <MessageSquare className="h-12 w-12" />
          <p>No messages yet. Share your contact page to start receiving inquiries!</p>
          <p className="empty-link">Contact page: <code>/contact</code></p>
        </div>
      )}
    </div>
  );
};

export default AdminMessagesTab;
